/* eslint-disable no-useless-escape */
/**
 * Format: Outfit
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API outfit metaobject responses.
 *
 */

import { formatProduct } from './format-product'

/**
 * Format outfit.
 * @param {Object} response - GraphQL response.
 * @returns {Object}
 */
export function formatOutfit(response) {
  const outfit = response.metaobject

  if (!outfit) {
    return null
  }

  let mobileCollageTemplate = 'a'
  const match = outfit.mobile_collage_template.value.match(/^Template (?<template>\w)/g)

  if (match.length) {
    mobileCollageTemplate = match[0]
      .replace('Template', '')
      .trim()
      .toLowerCase()
  }

  return {
    product1: outfit.product_1?.value
      ? formatProduct(outfit.product_1.value)
      : null,
    product2: outfit.product_2?.value
      ? formatProduct(outfit.product_2.value)
      : null,
    product3: outfit.product_3?.value
      ? formatProduct(outfit.product_3.value)
      : null,
    product4: outfit.product_4?.value
      ? formatProduct(outfit.product_4.value)
      : null,
    product5: outfit.product_5?.value
      ? formatProduct(outfit.product_5.value)
      : null,
    metaobjectName: outfit.metaobject_name?.value,
    mobileCollageTemplate,
    title: outfit.title?.value || null,
    additionalText: outfit.additional_text?.value || null,
  }
}
